import { render, staticRenderFns } from "./addQc_table.vue?vue&type=template&id=e450fdac&scoped=true"
import script from "./addQc_table.vue?vue&type=script&lang=js"
export * from "./addQc_table.vue?vue&type=script&lang=js"
import style0 from "./addQc_table.vue?vue&type=style&index=0&id=e450fdac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e450fdac",
  null
  
)

export default component.exports